export default __webpack_public_path__ + "static/media/001-home.2ed360dd.png";